import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function associateProject(projectId, value, action = 'by_prescription_test_id') {
  const axios = axiosInstance().primoLab;

  try {
    const params = {
      project_id: projectId,
      action,
    };

    if (action === 'by_prescription_test_id') {
      params.prescription_test_id = value;
    } else if (action === 'by_number_text') {
      params.number_text = value;
    } else {
      throw new Error('Invalid action');
    }

    const response = await axios.post(`/projects/associate`, null, {
      params,
    });

    return { project: response.data, message: "Project associated successfully" };
  } catch (error) {
    const errorMessages = error.response?.data?.errors || ['An unexpected error occurred'];
    throw new Error(errorMessages.join(', '));
  }
}